import { Injectable } from "@angular/core";
import { ApolloQueryResult } from "@apollo/client/core";
import { Apollo, gql } from "apollo-angular";
import { Observable, retry, shareReplay } from "rxjs";
import { GQLService } from "../../core";
import { GET_PRODUCT_BY_CATEGORY_SLUG, GET_PRODUCT_BY_SLUG } from "./query/product-query.gql";

@Injectable({
  providedIn: "root"
})
export class ProductGql extends GQLService {
  constructor(protected override apollo: Apollo) {
    super(apollo);
  }

  findByCategorySlug(categorySlug: string): Observable<ApolloQueryResult<any>> {
    return this.watchQuery(GET_PRODUCT_BY_CATEGORY_SLUG, { categorySlug }).valueChanges.pipe(retry({count:3,delay:3000}));
  }

  findBySlug(slug: string): Observable<ApolloQueryResult<any>> {
    return this.watchQuery(GET_PRODUCT_BY_SLUG, { slug }).valueChanges.pipe(retry({count:3,delay:3000}));
  }
}